import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdBreaksActionProvider } from '@vdms-hq/asset-details';

/**
 * Adapter that implements AdBreaksActionProvider for the vida app.
 * Bridges the gap between the generic provider interface and the concrete ad breaks dialog.
 * Breaks the circular dependency by having the adapter (not ActiveAssetActionService) import the dialog.
 */
@Injectable({ providedIn: 'root' })
export class AdBreaksActionAdapter implements AdBreaksActionProvider {
  private dialog = inject(MatDialog);

  // Lazy-load the modal so it is code-split out of the eager bundle (fetched only when opened).
  async openAdBreaksSuggestions(): Promise<void> {
    const { AdBreakModalComponent } = await import('../components/ad-break-modal/ad-break-modal.component');
    this.dialog.open(AdBreakModalComponent);
  }
}
